import React from 'react'

const CustomerDetailContext = React.createContext({})

export default CustomerDetailContext